import { useQuery } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

import type { CompetitorSourceName } from '~/types/services/priceParrot';

import { competitorOffersQueryKeys } from './competitorOffersQueryKeys';

export function useGetCompetitorPropertyOptions(
  sourceName: CompetitorSourceName,
  externalPropertyId: string,
  enabled = true,
) {
  return useQuery({
    queryKey: competitorOffersQueryKeys.options(sourceName, externalPropertyId),
    queryFn: async ({ signal }) =>
      (await PriceParrotService.getCompetitorPropertyOptions(sourceName, externalPropertyId, signal)).data,
    enabled,
  });
}
